import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Layout from "../components/Layout";
import FaqList from "../containers/Faq";
import { getFaq } from "../containers/Faq/faqActions";
import { getProfile } from "../containers/Login/rolesActions";
import UserService from "../services/UserService";

class Faq extends Component {
  static async getInitialProps({ query, reduxStore, req }) {
    let isLogin = !!UserService.getAccessToken(req);
    await reduxStore.dispatch(getFaq());
    return { query, isLogin };
  }

  componentDidMount() {
    const { isLogin, getProfile } = this.props;
    if (isLogin) {
      getProfile();
    }
  }

  render() {
    const { isLogin } = this.props;
    const title = "FAQs - Recruiters self help guide - jobhai.com";
    const metaDescription =
      "Learn how to post a job, jobhai login related queries and many more.Request a call back or follow our self learning faqs on jobhai.com.";
    const canonical = `${process.env.LIVE_URL_HIRE}/recruiter-faqs`;
    const breadcrumbList = [
      {
        title: "Post Job",
        label: "Post Job",
        url: `${process.env.LIVE_URL_HIRE}`
      },
      { title: "Faqs", label: "Faqs", url: `` }
    ];
    return (
      <div>
        <Layout
          isFooter={false}
          title={title}
          metaDescription={metaDescription}
          breadcrumbList={breadcrumbList}
          pathname={"recruiter-faqs"}
          canonical={canonical}
          isAuthNavigationEnabled={false}
          isLogin={isLogin}
        >
          <FaqList breadcrumbList={breadcrumbList} />
        </Layout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getProfile }, dispatch);
};

export default connect(null, mapDispatchToProps)(Faq);
